import React from 'react';
import { Helmet } from 'react-helmet';

const WorkEnvironmentPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Arbetsmiljöpolicy - Provalt Service AB</title>
        <meta
          name="description"
          content="Vår arbetsmiljöpolicy beskriver hur vi på Provalt Service AB arbetar för att skapa en trygg, hälsosam och hållbar arbetsmiljö för alla medarbetare."
        />
          <link rel="canonical" href="https://provalt.se/arbetspolicy" />

      </Helmet>

      <section className="w-full py-16 px-4 sm:px-8 bg-white text-gray-800">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-10 text-center">Arbetsmiljöpolicy</h1>

          <section className="mb-10">
            <h2 className="text-2xl font-semibold mb-2">Syfte</h2>
            <p>
              På Provalt Service AB är vi engagerade i att skapa och upprätthålla en säker, hälsosam och trivsam
              arbetsmiljö för alla våra medarbetare. En god arbetsmiljö är en grundläggande förutsättning för hög
              kvalitet i vårt arbete och för att främja välbefinnande och engagemang hos personalen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-semibold mb-2">Mål</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Skapa en säker arbetsmiljö som förebygger olyckor och skador.</li>
              <li>Främja fysisk och psykisk hälsa hos våra medarbetare.</li>
              <li>Säkerställa att arbetsuppgifter utförs ergonomiskt och hållbart.</li>
              <li>Uppmuntra till dialog och samarbete kring arbetsmiljöfrågor.</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-semibold mb-2">Våra åtaganden</h2>
            <ol className="list-decimal pl-6 space-y-4">
              <li>
                <strong>Förebyggande åtgärder:</strong>
                <ul className="list-disc pl-6 mt-1">
                  <li>
                    Identifiera och minimera arbetsmiljörisker regelbundet. Vi tillhandahåller säkerhetsutrustning och
                    ergonomiska hjälpmedel anpassade för städ- och trädgårdsarbete.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Utbildning och medvetenhet:</strong>
                <ul className="list-disc pl-6 mt-1">
                  <li>
                    Vi erbjuder löpande utbildningar inom arbetsmiljö och säkerhet, inklusive maskinhantering,
                    kemikalier och ergonomi, för att säkerställa trygga och effektiva arbetsinsatser.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Hälsa och välbefinnande:</strong>
                <ul className="list-disc pl-6 mt-1">
                  <li>
                    Vi arbetar för balans mellan arbete och privatliv, främjar friskvård och motverkar stress genom
                    aktiva insatser.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Medarbetarnas delaktighet:</strong>
                <ul className="list-disc pl-6 mt-1 space-y-1">
                  <li>
                    Vi uppmuntrar till att rapportera risker och komma med förbättringsförslag.
                  </li>
                  <li>
                    Vi håller en öppen dialog kring arbetsmiljöfrågor och samlar regelbundet in feedback.
                  </li>
                </ul>
              </li>
              <li>
                <strong>Efterlevnad av lagar och regler:</strong>
                <ul className="list-disc pl-6 mt-1">
                  <li>
                    Vi följer gällande arbetsmiljölagstiftning och samarbetar med myndigheter för att uppfylla krav och
                    standarder.
                  </li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-semibold mb-2">Ansvarsfördelning</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Arbetsgivaren</strong> har det övergripande ansvaret för att arbetsmiljöarbetet bedrivs
                systematiskt och strukturerat.
              </li>
              <li>
                <strong>Medarbetarna</strong> ansvarar för att följa säkerhetsföreskrifter och bidra till en positiv
                arbetsmiljö.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">Uppföljning och utvärdering</h2>
            <p>
              Vi utvärderar regelbundet vårt arbetsmiljöarbete för att säkerställa att vår policy efterlevs och att
              målen uppnås. Policyn revideras vid behov för att möta nya krav och insikter.
            </p>
          </section>
        </div>
      </section>
    </>
  );
};

export default WorkEnvironmentPolicy;
